<template>
    <page title="competitionApprovalRequest" :textHeight="(WindowSize.y - 276) + 'px'">
        <template #pageContainer>
			<v-form ref="form" v-model="valid">
				<v-row><v-col>
					<p v-html="$t(`text.createApprovalHint1`)"></p>
					<p>{{ $t(`text.createApprovalHint2`) }}</p>
				</v-col></v-row>
				<!-- <v-row><v-col>
					<c-checkbox type="checkbox"
						:text="$t(`text.stopEmails`)"
						v-model="stopMails">
					</c-checkbox>
				</v-col></v-row> -->
            </v-form>
            <spinner :loading="loading"></spinner>
        </template>
		<template #pageActions>
			<v-row>
				<v-col>
					<v-btn
						class="mr-4"
						@click="backToOverview">
						{{ $t(`text.backToOverview`) }}
					</v-btn>
					<v-btn
						class="mr-4"
						:disabled="!isApprovable"
						@click="save">
						{{ $t(`text.insertCompetition`) }}
					</v-btn>
					<v-btn
						class="mr-4"
						@click="back">
						{{ $t(`text.backButton`) }}
					</v-btn>
				</v-col>
			</v-row>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import compApprovalActions from '../store/actions/compApproval';
import namespace from '../store/namespace';

import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';

export default {
	name: 'CompetitionApprovalRequest',
	components: {
		Page,
		Spinner,
	},
	data() {
		return {
			valid: true,
			loading: false,
			stopMails: false,
		};
	},
	async mounted() {
		this.loading = true;
		if (this.CompApprLinks.length === undefined || this.CompApprLinks.length === 0) {
			await this.GET_COMP_APPROVAL_LINKS();
		}
		if (!this.Competition || this.Competition.id !== this.cGuid) {
			const link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
			if (link) {
				await this.GET_COMP_BY_ID({ link, cGuid: this.cGuid });
			}
		}
		this.loading = false;
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.COMPETITIONAPPROVAL, ['CompApprLinks', 'Competition']),
		cGuid() {
			return this.$route.params.cGuid || null;
		},
		isApprovable() {
			if (!this.Competition) return null;
			return [0, 2].includes(this.Competition.competitionState);
		},
	},
	methods: {
		...mapActions(namespace.COMPETITIONAPPROVAL, [
			compApprovalActions.GET_COMP_APPROVAL_LINKS,
			compApprovalActions.GET_COMP_BY_ID,
			compApprovalActions.REQUEST_COMP_APPROVAL,
		]),
		async save() {
			this.loading = true;
			const link = this.CompApprLinks.find(x => x.rel === 'request_comp_approval');
			if (link) {
				await this.REQUEST_COMP_APPROVAL({ link, cGuid: this.cGuid });
			}
			this.$router.push({ name: 'competitionapproval' });
			this.loading = false;
		},
		back() {
			this.$router.go(-1);
		},
		backToOverview() {
			this.$router.push({
				name: 'competitionapproval',
			});
		},
	},
};
</script>
